/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../../elements/Header";
import Footer from "../../elements/Footer";
import FAQ from "../../elements/FAQ";
import { EnvContext } from "../../context/EnvContext";
import { useFirestore } from "../../firebase/FirestoreContext";
import { collection, getDocs, query, where, and } from "firebase/firestore"; // Import query and where
import config from "../../config";
import NavigationSimple from "../../elements/NavigationSimple";
import { useNavigate } from "react-router-dom";
import FeaturedCarousel_Knowledge from "../../elements/FeaturedCarousel_Knowledge";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const Knowledge = ({ isDevMode }) => {
  const { id } = useParams(); // Get the knowledge ID from the URL
  const [knowledgeList, setKnowledgeList] = useState([]); // State for the list of knowledge items
  const [knowledgeItem, setKnowledgeItem] = useState(null); // State for the selected knowledge item
  const db = useFirestore();
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchKnowledge = async () => {
      if (!db) {
        console.error("Firestore instance is not initialized.");
        return;
      }
      try {
        let knowledgeData = [];
        const knowledgeCollection = collection(db, `${collectionPath}Help/Knowledge/DataBase`);

        if (id) {
          // If ID is present, fetch single knowledge item based on customURL
          const q = query(knowledgeCollection, and(where("customURL", "==", id)));

          const knowledgeSnapshot = await getDocs(q);

          if (!knowledgeSnapshot.empty) {
            knowledgeData = knowledgeSnapshot.docs.map((doc) => {
              const data = {
                id: doc.id,
                ...doc.data(),
              };
              console.log("Knowledge Data:", data); // Log the data
              return data;
            });
          } else {
            console.log("Knowledge document does not exist");
            knowledgeData = [];
          }
        } else {
          // If ID is not present, fetch all knowledge items
          const q = query(knowledgeCollection, where("featured", "==", false));
          const knowledgeSnapshot = await getDocs(q);
          knowledgeData = knowledgeSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        }

        knowledgeData.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));

        setKnowledgeList(knowledgeData);
        setKnowledgeItem(knowledgeData.length > 0 ? knowledgeData[0] : null); // Set the first item as knowledgeItem if available
      } catch (error) {
        console.error("Error fetching knowledge:", error);
      }
    };

    fetchKnowledge();
  }, [db, collectionPath, id]);

  // If ID is present but no knowledge item is found, display loading message
  if (id && knowledgeList.length === 0) {
    return (
      <>
        <Header search={false} />
        <NavigationSimple categoryTitle="Loading..." />
        <div>Loading...</div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header search={false} />
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          borderTop: "1px solid black",
          marginTop: 35,
          maxWidth: "1140px",
          margin: "0 auto"
        }}
      >
        {id ? (
          <NavigationSimple categoryTitle={""} onClick={() => (window.location.href = `/knowledge`)} containerStyle={{ marginTop: 20 }} />
        ) : (
          <div style={{ ...styles.title }}>Knowledge Center</div>
        )}
        <div style={{ padding: "15px", flex: 1 }}>
          {!id && (
            <div style={{}}>
              <FeaturedCarousel_Knowledge />
            </div>
          )}

          {!id && <div style={{ ...styles.title, margin: "40px 0 10px 0" }}>More Articles</div>}
          {knowledgeList.map((item) => (
            <div key={item.id} css={{ marginBottom: 30, cursor: "pointer", display: "flex", flexDirection: "column", [mq[0]]: { flexDirection: "row", marginBottom: 60 } }} onClick={() => navigate(`/knowledge/${item.customURL}`)}>
              {/* Image Container with Overlaid Title */}
              {item.image ? (
                <div css={{ position: "relative", borderRadius: 8, overflow: "hidden", [mq[0]]: { minWidth: "50%" } }}>
                  <img
                    src={item.image}
                    alt={item.title}
                    css={{
                      width: "100%",
                      height: "auto",
                      maxHeight: 200,
                      display: "block",
                      objectFit: "cover",
                      borderRadius: 8,
                      [mq[0]]: {
                        maxWidth: 540,
                        maxHeight: 300,
                      }
                    }}
                  />
                  {/* Title overlay at the bottom-left corner */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 10,
                      left: 10,
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: 4,
                      textShadow: "2px 2px 10px rgba(0, 0, 0, 0.4)",
                    }}
                  >
                    <h2 style={{ margin: 0, fontSize: "1.2rem" }}>{item.title}</h2>
                  </div>
                </div>
              ) : (
                <h2 css={{ margin: 0, fontSize: "1.1rem", [mq[0]]: { minWidth: "50%" } }}>{item.title}</h2>
              )}
              <div css={{ [mq[0]]: { marginLeft: "30px" } }}>
                {/* Description */}

                {/* Short Description */}
                {id && (
                  <div
                    style={{
                      padding: "10px 0 5px 0",
                      fontWeight: 500,
                      fontSize: "0.9rem",
                    }}
                    className="ql-editor"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                )}

                {/* Read more link - Conditionally render if on the list page */}
                {!id && (
                  <>
                    <div
                      style={{
                        padding: "10px 0 5px 0",
                        fontWeight: 500,
                        fontSize: "0.9rem",
                      }}
                      className="knowledge-short-description"
                      dangerouslySetInnerHTML={{ __html: item.shortDescription }}
                    />
                    <Link to={`/knowledge/${item.customURL}`} style={{ fontSize: "0.85rem", color: "black", textDecoration: "underline", fontWeight: 600 }}>
                      Read more...
                    </Link>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
        <FAQ />
      </div>
      <Footer />
    </>
  );
};

export default Knowledge;

const styles = {
  title: {
    fontSize: "1.3rem",
    fontWeight: 700,
    margin: "15px",
  },
};
